/* eslint-disable react/no-danger */
import React from 'react';

import { useEvieAppContext } from 'components/evieApp/EvieAppProvider';

const ProgramContentDescription = () => {
  const { program: { description = '' } = {} } = useEvieAppContext();

  return (
    <section className="program-content">
      <p dangerouslySetInnerHTML={{ __html: description }} />
    </section>
  );
};

export default ProgramContentDescription;
